import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

const inputClass =
  "w-full rounded-xl border border-choco-line bg-choco px-4 py-2.5 text-sm text-cream-text placeholder:text-cream-muted/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-focus";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.post("/admin/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-choco px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl border border-choco-line bg-choco-light p-8" noValidate data-testid="admin-login-form">
        <img src="/assets/logo.png" alt="Bakes by CR" className="h-16 w-auto" />
        <h1 className="mt-4 font-serif text-2xl font-bold text-cream-text">
          Admin Sign In
        </h1>
        <p className="mt-1 text-sm text-cream-muted">Sign in to manage your shop.</p>

        <div className="mt-6 space-y-4">
          <div>
            <label htmlFor="admin-email" className="mb-1.5 block text-sm font-semibold text-cream-text">Email</label>
            <input id="admin-email" type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass} data-testid="admin-login-email-input" />
          </div>
          <div>
            <label htmlFor="admin-password" className="mb-1.5 block text-sm font-semibold text-cream-text">Password</label>
            <input id="admin-password" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputClass} data-testid="admin-login-password-input" />
            <Link to="/admin/forgot-password" className="mt-2 block text-right text-xs font-semibold text-cream-muted hover:text-gold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-focus rounded-full" data-testid="forgot-password-link">
              Forgot your password?
            </Link>
          </div>
        </div>

        {error && (
          <p className="mt-4 text-sm font-semibold text-red-400" role="alert" data-testid="admin-login-error">{error}</p>
        )}
        <button
          type="submit"
          disabled={busy}
          className="mt-6 w-full rounded-full bg-gold px-6 py-3 text-sm font-bold text-choco transition-colors hover:bg-gold-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-focus active:scale-[0.98] disabled:opacity-60"
          data-testid="admin-login-submit-button"
        >
          {busy ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </div>
  );
}
